import i18n from "../../services/store/i18n";

export default (translate: string, params?: { [k: string]: any }): string => {
  return i18n.t(translate, params);
};
